import React from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import AdminLayout from "./components/Admin/layout";
import PageNotFound from "./components/PageNotFount";
import Signin from "./components/Signin";
import UserSignin from "./components/User/UserSignin";
import UserDashBoard from "./components/User/DashBoard/UserDashBoard";
import NewLicense from "./components/User/License/NewLicense";
import CreateNewLicense from "./components/User/License/CreateNewLicense";
import Userviewlicense from "./components/User/License/Userviewlicense";
import {
  SIGNIN_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  ADMIN_LAYOUT_ROUTE,
  AGENCY_LAYOUT_ROUTE,
  USER_SIGNIN,
  USER_DASHBOARD,
  USER_NEW_LICENSE,
  USER_PREVIEW_PLAN,
  USER_CHOOSE_PLAN,
  USER_CREATE_LICENSE,
  INITIAL_LAYOUT,
  AGENCY_DASHBOARD_ROUTE,
  ADMIN_DASHBOARD_ROUTE,
  FORGET_PASSWORD,
  USER_FORGET_PASSWORD,
  USER_SIGNIN_UP,
  AGENCY_CREATE_FORM,
  USER_PAYMENT,
  CUSTOMER_VIEW_LICENSE,
  SIGNIN_AUTH_ROUTE,
  AGENCY_TEMPLATE_FORM,
  AGENCY_EMPLOYEE_ROUTE,
  AGENCY_SETTINGS,
  AGENCY_CUSTOMER_DETAILS_ROUTE,
  PAYMENT_SUCCESS,
  GUEST_USER_LICENSE,
  GUEST_DETAILS,
  GUEST_CHOOSE_PLAN,
  AGENCY_VIEW_LICENSE_ROUTE,
  AGENCY_CUSTOMER_ROUTE,
  AGENCY_LICENSE_ROUTE,
  AGENCY_CREATE_TEMPLATE,
  GUEST_USER,
  AGENCY_PAYMENT,
  AGENCY_TEMPLATE_ROUTE,
  AGENCY_KERNEL_LICENSE,
  ADMIN_AGENCY_REPORT,
  ADMIN_PAYMENT_REPORT,
  ADMIN_SETTINGS,
  ADMIN_LICENSE_DETAILS,
  ADMIN_CUSTOMER_LICENSE,
  ADMIN_CUSTOMER_DETAILS,
  ADMIN_EMPLOYEE_CREATE_ROUTE,
  ADMIN_EMPLOYEE_ROUTE,
  TEMPLATE_FORM_DETAILS,
  ADMIN_AGENCY_DETAILS,
  ADMIN_AGENCY_TEMPLATES,
  ADMIN_AGENCY_UPDATE,
  ADMIN_AGENCY_CREATE_ROUTE,
  ADMIN_AGENCY_ROUTE,
  TEMPLATE_DETAILS,
  AGENCY_CUSTOMER_PAYMENT_REPORT,
  AGENCY_CUSTOMER_REPORT,
  AGENCY_LICENSE_REPORT,
  AGENCY_PLAN_SITE,
} from "./constants/RoutePaths";
import AgencyLayout from "./components/Agency/layout";
import CustomerForgrtPassword from "./components/User/CustomerForgetPassword";
import PublicRoute, {
  AgencyPrivateRoute,
  authUserRole,
  CustomerPrivateRoute,
  CustomerPublicRoute,
  PrivateRoute,
} from "./functions/CoreFunctions";
import ForgetPassword from "./components/ForgetPassword";
import UserSignUp from "./components/User/UserSignUp";
import Chooseplan from "./components/User/License/Chooseplan";
import CustomerPayment from "./components/User/License/Payment";
import CreateForm from "./components/Agency/FormGeneration/CreateForm";
import Previewplan from "./components/User/License/Previewplan";
import UserSettings from "../src/components/User/Settings/UserSettings";
import ViewLicense from "./components/Agency/Customer/ViewLicense";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import Swipetype from "./components/Agency/Swipetype";
import SigninAuthPage from "./components/SigninAuthPage";
import AdminDashBoard from "./components/Admin/DashBoard/DashBoard";
import AgencyDashBoard from "./components/Agency/DashBoard/AgencyDashBoard";
import GuestChooseplan from "./components/Agency/Poc/GuestChooseplan";
import GuestDetails from "./components/Agency/Poc/GuestDetails";
import GuestLicence from "./components/Agency/Poc/GuestLicence";
import SuccessPayment from "./components/Agency/Payment/SuccessPayment";
import AgencyCustomerPaymentReport from "./components/Agency/Report/AgencyCustomerPaymentReport";
import AgencySettings from "./components/Agency/Settings/AgencySettings";
import AgencyEmployee from "./components/Agency/Employee/AgencyEmployee";
import Licensecategories from "./components/Agency/Template/Licensecategories";
import Customer from "./components/Agency/Customer/Customer";
import LicenseList from "./components/Agency/License/LicenseList";
import CreateTemplate from "./components/Agency/Template/CreateTemplate";
import Poc from "./components/Agency/Poc/Poc";
import LicenseReport from "./components/Agency/Report/LicenseReport";
import AgencyCustomerReport from "./components/Agency/Report/AgencyCustomerReport";
import AgencyPayment from "./components/User/License/Payment";
import TemplateList from "./components/Agency/Template/TemplateList";
import Kernellicense from "./components/Agency/kernellicense/Kernellicense";
import AgencyReport from "./components/Admin/Report/AgencyReport";
import PaymentReport from "./components/Admin/Report/PaymentReport";
import Settings from "./components/Admin/Settings/Settings";
import LicenseDetails from "./components/Admin/Agency/LicenseDetails";
import CustomerLicense from "./components/Admin/Agency/CustomerLicense";
import EmployeeCreate from "./components/Admin/Employee/EmployeeCreate";
import Employee from "./components/Admin/Employee/Employee";
import Viewtemplate from "./components/Admin/Templates/Viewtemplate";
import AgencyDetails from "./components/Admin/Agency/AgencyDetails";
import AgencyTemplates from "./components/Admin/Templates/AgencyTemplates";
import AgencyUpdate from "./components/Admin/Agency/AgencyUpdate";
import AgencyCreate from "./components/Admin/Agency/AgencyCreate";
import AdminAgency from "./components/Admin/Agency/Agency";
import TemplateDetails from "./components/Admin/Templates/TemplateDetails";
import CustomerDetails from "./components/Agency/Customer/CustomerDetails";

function App() {
  const authRole = authUserRole();
  console.log('authRole',authRole)
  const { enqueueSnackbar } = useSnackbar();
  const Delete = useSelector((state) => state.Agencydelete);
  const location=useLocation()
  if (Delete) {
    enqueueSnackbar("Your Agency is Deleted", {
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      variant: "error",
      persist: true,
    });
  }
  return (
    <>
      {location && location.pathname.split("/")[1] === "agency" ? (
        <AgencyLayout />
      ) : (
        <></>
      )}
      {location && location.pathname.split("/")[1]==="admin" ? <AdminLayout /> : <></>}
      <Routes>
        <Route
          path={SIGNIN_ROUTE}
          element={
            <PublicRoute>
              <Signin />
            </PublicRoute>
          }
        />
        <Route
          path={SIGNIN_AUTH_ROUTE}
          element={
            <PublicRoute>
              <SigninAuthPage />
            </PublicRoute>
          }
        />
        <Route
          path={FORGET_PASSWORD}
          element={
            <PublicRoute>
              <ForgetPassword />
            </PublicRoute>
          }
        />
        <Route
          path={AGENCY_CREATE_FORM}
          element={
            <PrivateRoute>
              <CreateForm />
            </PrivateRoute>
          }
        />
        <Route
          path={ADMIN_LAYOUT_ROUTE}
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        />
        {/* <Route
        path={AGENCY_LAYOUT_ROUTE}
        element={
          <PrivateRoute>
            <AgencyLayout />
          </PrivateRoute>
        }
      /> */}
        <Route
          path={AGENCY_DASHBOARD_ROUTE}
          element={
            <PrivateRoute>
              <AgencyDashBoard />
            </PrivateRoute>
          }
        />

        <Route
          path={INITIAL_LAYOUT}
          element={
            // [ROOT_ADMIN, ROOT_EMPLOYEE].includes(authRole) ? 
              <Navigate to={SIGNIN_ROUTE} replace/>
              // :
              // <Navigate to={AGENCY_DASHBOARD_ROUTE} replace/>
            }
             
          
        />
        {/* <Route
          path={ADMIN_LAYOUT_ROUTE}
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        /> */}
        <Route
          path={AGENCY_LAYOUT_ROUTE}
          element={
            <PrivateRoute>
              <AgencyLayout />
            </PrivateRoute>
          }
        />
        {/* User */}
        <Route
          path={`${USER_SIGNIN}/:${"agencyUrl"}`}
          element={
            <CustomerPublicRoute>
              <UserSignin />
            </CustomerPublicRoute>
          }
        />
         <Route
          path={`${AGENCY_PLAN_SITE}/:${"agencyUrl"}`}
          element={
            <AgencyPrivateRoute>
              <UserSignin />
            </AgencyPrivateRoute>
          }
        />
        <Route
          path={USER_SIGNIN_UP}
          element={
            <CustomerPublicRoute>
              <UserSignUp />
            </CustomerPublicRoute>
          }
        />
        <Route
          path={USER_FORGET_PASSWORD}
          element={
            <CustomerPublicRoute>
              <CustomerForgrtPassword />
            </CustomerPublicRoute>
          }
        />
        <Route
          path={USER_DASHBOARD}
          element={
            <CustomerPrivateRoute>
              <UserDashBoard />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={USER_NEW_LICENSE}
          element={
            <CustomerPrivateRoute>
              <NewLicense />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={USER_CREATE_LICENSE}
          element={
            <CustomerPrivateRoute>
              <CreateNewLicense />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={`${USER_CHOOSE_PLAN}/:${"licensePlanId"}/:${"DogId"}`}
          element={
            <CustomerPrivateRoute>
              <Chooseplan />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={USER_PAYMENT}
          element={
            <CustomerPrivateRoute>
              <CustomerPayment />
            </CustomerPrivateRoute>
          }
        />
        <Route
          // path={`${"customer/"}/:${"dogLicenseId"}/:${"agencyname"}`}
          path="/customer/:agencyname/view-license/:licensePlanId/:dogLicenseId"
          element={<Userviewlicense />}
        />
        <Route
          // path={`${"customer/"}/:${"dogLicenseId"}/:${"agencyname"}`}
          path="/agencyplan/:agencyname/view-license/:licensePlanId/:dogLicenseId"
          element={<Userviewlicense />}
        />
        <Route
          path={USER_PREVIEW_PLAN}
          element={
            <CustomerPrivateRoute>
              <Previewplan />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path="/UserSettings"
          element={
            <CustomerPrivateRoute>
              <UserSettings />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path="/privacy"
          element={
            <PrivateRoute>
              <Privacy />
            </PrivateRoute>
          }
        />
        <Route
          path="/terms"
          element={
            <PrivateRoute>
              <Terms />
            </PrivateRoute>
          }
        />
        <Route
          path={`${CUSTOMER_VIEW_LICENSE}/:${"licensePlanId"}/:${"dogLicenseId"}`}
          element={<ViewLicense />}
        />
        <Route path={"/card-swipe-test"} element={<Swipetype />} />
        <Route path={PAGE_NOT_FOUND_ROUTE} element={PageNotFound} />
        {/* User */}
        <Route
          path={`${USER_SIGNIN}/:${"agencyUrl"}`}
          element={
            <CustomerPublicRoute>
              <UserSignin />
            </CustomerPublicRoute>
          }
        />
        <Route
          path={`${AGENCY_PLAN_SITE}/:${"agencyUrl"}`}
          element={
            <AgencyPrivateRoute>
              <UserSignin />
            </AgencyPrivateRoute>
          }
        />
        <Route
          path={USER_SIGNIN_UP}
          element={
            <CustomerPublicRoute>
              <UserSignUp />
            </CustomerPublicRoute>
          }
        />
        <Route
          path={USER_FORGET_PASSWORD}
          element={
            <CustomerPublicRoute>
              <CustomerForgrtPassword />
            </CustomerPublicRoute>
          }
        />
        <Route
          path={USER_DASHBOARD}
          element={
            <CustomerPrivateRoute>
              <UserDashBoard />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={USER_NEW_LICENSE}
          element={
            <CustomerPrivateRoute>
              <NewLicense />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={USER_CREATE_LICENSE}
          element={
            <CustomerPrivateRoute>
              <CreateNewLicense />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={`${USER_CHOOSE_PLAN}/:${"licensePlanId"}/:${"DogId"}`}
          element={
            <CustomerPrivateRoute>
              <Chooseplan />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path={USER_PAYMENT}
          element={
            <CustomerPrivateRoute>
              <CustomerPayment />
            </CustomerPrivateRoute>
          }
        />
        <Route
          // path={`${"customer/"}/:${"dogLicenseId"}/:${"agencyname"}`}
          path="/customer/:agencyname/view-license/:licensePlanId/:dogLicenseId"
          element={<Userviewlicense />}
        />
        <Route
          // path={`${"customer/"}/:${"dogLicenseId"}/:${"agencyname"}`}
          path="/agencyplan/:agencyname/view-license/:licensePlanId/:dogLicenseId"
          element={<Userviewlicense />}
        />
        <Route
          path={USER_PREVIEW_PLAN}
          element={
            <CustomerPrivateRoute>
              <Previewplan />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path="/UserSettings"
          element={
            <CustomerPrivateRoute>
              <UserSettings />
            </CustomerPrivateRoute>
          }
        />
        <Route
          path="/privacy"
          element={
            <PrivateRoute>
              <Privacy />
            </PrivateRoute>
          }
        />
        <Route
          path="/terms"
          element={
            <PrivateRoute>
              <Terms />
            </PrivateRoute>
          }
        />
        <Route
          path={`${CUSTOMER_VIEW_LICENSE}/:${"licensePlanId"}/:${"dogLicenseId"}`}
          element={<ViewLicense />}
        />
        <Route path={"/card-swipe-test"} element={<Swipetype />} />
        <Route path={PAGE_NOT_FOUND_ROUTE} element={PageNotFound} />
        {/* </Switch> */}

        <Route
          exact
          path={AGENCY_KERNEL_LICENSE}
          element={
            <PrivateRoute>
              <Kernellicense />
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={AGENCY_TEMPLATE_ROUTE}
          element={
            <PrivateRoute>
              <TemplateList />
            </PrivateRoute>
          }
        />
        <Route
          path={`${AGENCY_PAYMENT}`}
          element={
            <PrivateRoute>
              <AgencyPayment />
            </PrivateRoute>
          }
        />

        <Route
          exact
          path={AGENCY_CUSTOMER_REPORT}
          element={
            <PrivateRoute>
              <AgencyCustomerReport />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AGENCY_LICENSE_REPORT}
          element={
            <PrivateRoute>
              <LicenseReport />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={GUEST_USER}
          element={
            <PrivateRoute>
              <Poc />
            </PrivateRoute>
          }
        />
        <Route
          path={`${AGENCY_CREATE_TEMPLATE}/:${"templateId"}`}
          element={
            <PrivateRoute>
              <CreateTemplate />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AGENCY_LICENSE_ROUTE}
          element={
            <PrivateRoute>
              <LicenseList />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AGENCY_CUSTOMER_ROUTE}
          element={
            <PrivateRoute>
              <Customer />
            </PrivateRoute>
          }
        />
        {/* <PrivateRoute
        exact
        path={AGENCY_CUSTOMER_ROUTE}
        component={CustomerPaymentDetails}
      /> */}
        <Route
          path={`${AGENCY_TEMPLATE_FORM}/:${"categoryId"}`}
          element={
            <PrivateRoute>
              <Licensecategories />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AGENCY_EMPLOYEE_ROUTE}
          element={
            <PrivateRoute>
              <AgencyEmployee />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AGENCY_SETTINGS}
          element={
            <PrivateRoute>
              <AgencySettings />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={AGENCY_CUSTOMER_PAYMENT_REPORT}
          element={
            <PrivateRoute>
              <AgencyCustomerPaymentReport />
            </PrivateRoute>
          }
        />
        <Route
          path={`${AGENCY_CUSTOMER_DETAILS_ROUTE}/:${"userId"}`}
          element={
            <PrivateRoute>
              <CustomerDetails />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={PAYMENT_SUCCESS}
          element={
            <PrivateRoute>
              <SuccessPayment />
            </PrivateRoute>
          }
        />
        <Route
          path={`${GUEST_USER_LICENSE}/:${"userId"}`}
          element={
            <PrivateRoute>
              <GuestLicence />
            </PrivateRoute>
          }
        />
        <Route
          path={`${GUEST_DETAILS}/:${"userId"}`}
          element={
            <PrivateRoute>
              <GuestDetails />
            </PrivateRoute>
          }
        />
        <Route
          path={`${GUEST_CHOOSE_PLAN}/:${"userId"}/:${"licensePlanId"}/:${"dogId"}`}
          element={
            <PrivateRoute>
              <GuestChooseplan />
            </PrivateRoute>
          }
        />
        <Route
          path={`${AGENCY_VIEW_LICENSE_ROUTE}/:${"licensePlanId"}/:${"dogLicenseId"}`}
          element={
            <PrivateRoute>
              <ViewLicense />
            </PrivateRoute>
          }
        />
        <Route
          path={TEMPLATE_DETAILS}
          element={
            <PrivateRoute>
              <TemplateDetails />
            </PrivateRoute>
          }
        />
        <Route
          path={ADMIN_DASHBOARD_ROUTE}
          element={
            <PrivateRoute>
              <AdminDashBoard />
            </PrivateRoute>
          }
        />
        <Route
          path={ADMIN_AGENCY_ROUTE}
          element={
            <PrivateRoute>
              <AdminAgency />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_AGENCY_CREATE_ROUTE}
          element={
            <PrivateRoute>
              <AgencyCreate />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={`${ADMIN_AGENCY_UPDATE}/:${"agencyid"}`}
          element={
            <PrivateRoute>
              <AgencyUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path={ADMIN_AGENCY_TEMPLATES}
          element={
            <PrivateRoute>
              <AgencyTemplates />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ADMIN_AGENCY_DETAILS}/:${"agencyId"}`}
          element={
            <PrivateRoute>
              <AgencyDetails />
            </PrivateRoute>
          }
        />
        <Route
          path={`${TEMPLATE_FORM_DETAILS}/:${"categoryId"}`}
          element={
            <PrivateRoute>
              <Viewtemplate />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_EMPLOYEE_ROUTE}
          element={
            <PrivateRoute>
              <Employee />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_EMPLOYEE_CREATE_ROUTE}
          element={
            <PrivateRoute>
              <EmployeeCreate />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_CUSTOMER_DETAILS}
          element={
            <PrivateRoute>
              <CustomerDetails />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_CUSTOMER_LICENSE}
          element={
            <PrivateRoute>
              <CustomerLicense />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_LICENSE_DETAILS}
          element={
            <PrivateRoute>
              <LicenseDetails />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_SETTINGS}
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_PAYMENT_REPORT}
          element={
            <PrivateRoute>
              <PaymentReport />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path={ADMIN_AGENCY_REPORT}
          element={
            <PrivateRoute>
              <AgencyReport />
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
